// Collapses the backend's three paged shapes into one canonical
// { data: [...], totalCount, ... } so CustomPagination works the same everywhere:
//   Spring Page  -> { data: { content, totalElements, ... } }
//   snake_case   -> { data: [...], total_count, page_size, current_page }
//   camelCase    -> { data: [...], totalCount, currentPage, size }
export const normalizePaged = (payload = {}, { page = 0, size } = {}) => {
    const raw = payload.data;
    const content = Array.isArray(raw) ? raw : (raw?.content ?? []);
    const meta = raw && !Array.isArray(raw) ? raw : payload;
    return {
      ...payload,
      data: content,
      totalCount:
        meta.totalCount ?? meta.total_count ?? meta.totalElements ?? content.length,
      size: meta.size ?? meta.page_size ?? size,
      currentPage: meta.currentPage ?? meta.current_page ?? meta.page ?? page,
      totalPages: meta.totalPages,
      hasNext: meta.hasNext ?? meta.has_next ?? false,
    };
  };